/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Provisioning Security Settings module.
────────────────────────────────────────────────────────────────*/

import { api } from '../../../lib/api';

export interface SecuritySettings {
    id?: number;
    uuid?: string;
    username: string;
    password?: string;
    enabled: boolean;
    domainId: number;
}

// API Functions
export const getSecuritySettings = () => api.get<SecuritySettings>('/api/apps/provisioning/security-settings').then(res => res.data);
export const updateSecuritySettings = (data: Partial<SecuritySettings>) => api.put<SecuritySettings>('/api/apps/provisioning/security-settings', data).then(res => res.data);
